import { serializeUrl } from '../internal/serialize-url'

export type BuildHomeUrlParams = {
  to?: 'home' | 'ai'
  params?: Record<string, string | number>
}

export const buildHomeUrl = ({ to, params }: BuildHomeUrlParams = {}): string => {
  const path = to === 'ai' ? '/home/ai' : '/home'

  return serializeUrl(path, { required: {}, optional: params ?? {} })
}
